<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-toolbar :class="{ 'red darken-2': isMailAll }" dark>
        <v-toolbar-title>{{ mailTypeText }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch
          v-model="isMailAll"
          label="전체 / 타겟"
          inset
          hide-details
        ></v-switch>
      </v-toolbar>

      <v-list>
        <!-- 타겟 유저 -->
        <v-list-item v-if="!isMailAll">
          <span style="width:160px"><v-card-title class="font-weight-bold">타겟 유저</v-card-title></span>
          <v-text-field
            label="유저 아이디 입력 (legacy_user_id)"
            v-model="targetUser"
            hide-details
          ></v-text-field>
        </v-list-item>
        <v-list-item v-else>
          <span style="width:160px"><v-card-title class="font-weight-bold">발송 대상</v-card-title></span>
          <v-chip color="red darken-2" dark small>전체 유저에게 발송됩니다</v-chip>
        </v-list-item>
        <v-divider/>

        <!-- 메일 제목 -->
        <v-list-item>
          <span style="width:160px"><v-card-title class="font-weight-bold">메일 제목</v-card-title></span>
          <v-text-field label="메일 발송 제목" v-model="mailTitle" hide-details></v-text-field>
        </v-list-item>
        <v-divider/>

        <!-- 메시지 -->
        <v-list-item class="mt-4">
          <span style="width:160px"><v-card-title class="font-weight-bold">메시지</v-card-title></span>
          <v-textarea filled v-model="mailMessage" label="메시지를 입력하세요." auto-grow rows="3"></v-textarea>
        </v-list-item>
        <v-divider/>

        <!-- 지급 아이템: POINT 만 -->
        <v-list-item class="mt-2">
          <span style="width:160px"><v-card-title class="font-weight-bold">지급 아이템</v-card-title></span>
          <v-chip color="indigo accent-3" dark small class="mr-3">POINT</v-chip>
          <v-text-field
            label="지급할 포인트"
            v-model.number="point"
            type="number"
            min="0"
            suffix="P"
            style="max-width:220px"
            hide-details
          ></v-text-field>
          <span class="grey--text text-caption ml-3">※ 프롬북 우편은 POINT 만 지급합니다.</span>
        </v-list-item>
        <v-divider/>

        <!-- 수령 가능 기간 -->
        <v-list-item class="mt-2">
          <span style="width:160px"><v-card-title class="font-weight-bold">수령 기간</v-card-title></span>
          <v-menu v-model="startMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="expireStartDate" label="시작일" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details style="max-width:200px" class="mr-4"></v-text-field>
            </template>
            <v-date-picker v-model="expireStartDate" @input="startMenu = false"></v-date-picker>
          </v-menu>
          <span class="mr-4">~</span>
          <v-menu v-model="endMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="expireEndDate" label="종료일" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details style="max-width:200px"></v-text-field>
            </template>
            <v-date-picker v-model="expireEndDate" @input="endMenu = false"></v-date-picker>
          </v-menu>
        </v-list-item>
      </v-list>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="indigo accent-3" dark large :loading="sending" @click="OnClick_Send">
          <v-icon left>mdi-email-fast-outline</v-icon>우편 발송
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- 발송 이력 -->
    <v-card class="mx-auto mt-6 mb-8" max-width="95%" elevation="1">
      <v-toolbar dark color="grey darken-1" dense>
        <v-toolbar-title class="text-subtitle-1">최근 우편 발송 이력</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="loadHistory" :loading="loadingHistory"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="historyList"
        :loading="loadingHistory"
        dense
        :items-per-page="30"
        class="prombook-mail-history"
      >
        <template v-slot:[`item.mail_type`]="{ item }">
          <v-chip x-small :color="item.mail_type === 'all' ? 'red darken-2' : 'blue-grey'" dark>{{ item.mail_type }}</v-chip>
        </template>
        <template v-slot:[`item.point`]="{ item }">
          {{ (item.mail_info && item.mail_info.point) ? Number(item.mail_info.point).toLocaleString() + ' P' : '-' }}
        </template>
        <template v-slot:[`item.title`]="{ item }">
          {{ item.mail_info && item.mail_info.title }}
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">{{ snackbarText }}</v-snackbar>
  </div>
</template>

<script>
import { prombook } from '../../api'

function ymd(d) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export default {
  name: 'PrombookGameMail',
  data() {
    const today = new Date()
    const end = new Date()
    end.setDate(end.getDate() + 30)
    return {
      isMailAll: false,
      targetUser: '',
      mailTitle: '',
      mailMessage: '',
      point: 0,
      expireStartDate: ymd(today),
      expireEndDate: ymd(end),
      startMenu: false,
      endMenu: false,
      sending: false,
      loadingHistory: false,
      historyList: [],
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      headers: [
        { text: 'ID', value: 'id', width: 70 },
        { text: '타입', value: 'mail_type', width: 90 },
        { text: '유저', value: 'user_id', width: 110 },
        { text: '포인트', value: 'point', width: 110 },
        { text: '제목', value: 'title' },
        { text: '발송일', value: 'created_at', width: 170 },
        { text: '발송자', value: 'created_by', width: 120 },
      ],
    }
  },
  computed: {
    mailTypeText() {
      return this.isMailAll ? '우편 발송 — 전체 유저' : '우편 발송 — 타겟 유저'
    },
  },
  created() {
    this.loadHistory()
  },
  methods: {
    notify(text, color = 'success') {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbar = true
    },
    formatDate(v) {
      if (!v) return '-'
      try { return new Date(v).toLocaleString() } catch (e) { return v }
    },
    async loadHistory() {
      this.loadingHistory = true
      try {
        const res = await prombook.get_mail_list_recent()
        const data = (res && res.response_data) ? res.response_data : res
        this.historyList = (data && data.recent_mail_list) ? data.recent_mail_list : []
      } catch (e) {
        console.error('[Prombook Mail] get_mail_list_recent', e)
        this.notify('발송 이력을 불러오지 못했습니다.', 'error')
      } finally {
        this.loadingHistory = false
      }
    },
    async OnClick_Send() {
      // 검증
      if (!this.isMailAll && !this.targetUser.trim()) {
        this.notify('타겟 유저 아이디를 입력하세요.', 'error')
        return
      }
      if (!this.mailTitle.trim()) {
        this.notify('메일 제목을 입력하세요.', 'error')
        return
      }
      const pointVal = Number(this.point) || 0
      if (pointVal <= 0) {
        this.notify('지급할 포인트를 입력하세요. (POINT 만 지급 가능)', 'error')
        return
      }
      const mail_type = this.isMailAll ? 'all' : 'single'
      const targetDesc = this.isMailAll ? '전체 유저' : this.targetUser.trim()
      const okConfirm = window.confirm(
        `[${targetDesc}] 에게\n포인트 ${pointVal.toLocaleString()}P 우편을 발송하시겠습니까?`
      )
      if (!okConfirm) return

      const mail_info = {
        point: pointVal,
        title: this.mailTitle.trim(),
        message: this.mailMessage,
      }
      const payload = {
        mail_type,
        user_id: this.isMailAll ? 'ALL' : this.targetUser.trim(),
        mail_info,
        expire_start: `${this.expireStartDate} 00:00:00`,
        expire_end: `${this.expireEndDate} 23:59:59`,
        admin_user: localStorage.user_id || 'cms',
      }

      this.sending = true
      try {
        await prombook.create_mail(payload)
        this.notify('우편을 발송했습니다.')
        // 폼 리셋 (대상/제목/메시지/포인트)
        this.targetUser = ''
        this.mailTitle = ''
        this.mailMessage = ''
        this.point = 0
        this.loadHistory()
      } catch (e) {
        console.error('[Prombook Mail] create_mail', e)
        this.notify('우편 발송에 실패했습니다. ' + (typeof e === 'string' ? e : ''), 'error')
      } finally {
        this.sending = false
      }
    },
  },
}
</script>

<style scoped>
.prombook-mail-history >>> td { font-size: 13px; }
</style>
